import {PhoneHQGlyph} from 'ch3-ui-lib';
import { useAuthenticatedMedia } from "../../hooks/useAuthenticatedMedia";
import type { MatrixEncryptedFile } from "../../utils/encryptedMedia";

interface VideoReplyPreviewProps {
    label?: string;
    thumbnailSrc?: string;
    thumbnailEncryptedFile?: MatrixEncryptedFile;
    thumbnailMimeType?: string;
}

export const VideoReplyPreview = ({
                                      label,
                                      thumbnailSrc,
                                      thumbnailEncryptedFile,
                                      thumbnailMimeType = 'image/jpeg',
                                  }: VideoReplyPreviewProps) => {
    const { blobUrl } = useAuthenticatedMedia(thumbnailSrc ?? '', thumbnailEncryptedFile, thumbnailMimeType);

    if (blobUrl) {
        return (
            <span className="relative inline-block" data-testid="chat.reply.video.thumbnail">
                <img src={blobUrl} alt={label || 'Video'} className="max-h-12 rounded" />
                <span className="absolute inset-0 flex items-center justify-center">
                    <PhoneHQGlyph name="play_circle_filled" size={24} className="text-white"/>
                </span>
            </span>
        );
    }

    return (
        <span className="inline-flex items-center gap-1" data-testid="chat.reply.video.label">
            <PhoneHQGlyph name="videocam" size={16}/>
            <span className="truncate">{label || 'Video'}</span>
        </span>
    );
};
